document.addEventListener("DOMContentLoaded", function () {
  const slider01 = document.querySelectorAll(".js-slider01");
  const slider02 = document.querySelectorAll(".js-slider02");
  const slider03 = document.querySelectorAll(".js-slider03");
  if (slider01) {
    slider01.forEach(function (element) {
      const slideContents = element.querySelectorAll(".splide__slide");
      const slideLength = slideContents.length;

      const splide = new Splide(element, {
        type: slideLength >= 5 ? "slide" : "",
        perPage: 4,
        perMove: 1,
        pagination: false,
        dots: false,
        pagination: false,
        gap: "8%",
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: slideLength >= 5 ? true : false,
        drag: slideLength >= 5 ? true : false,
        snap: slideLength >= 5 ? true : false,
        breakpoints: {
          767: {
            type: slideLength >= 3 ? "slide" : "",
            arrows: slideLength >= 3 ? true : false,
            drag: slideLength >= 3 ? true : false,
            snap: slideLength >= 3 ? true : false,
            gap: "3%",
            perPage: 2,
            fixedWidth: "42%",
          },
        },
      });
      splide.mount();
    });
    /* new Splide(slider01, {
      perPage: 4,
      dots: false,
      type: "slide",
      //speed: 1200,
      //rewind: true,
      pagination: false,
      gap: "8%",
      pauseOnHover: false,
      pauseOnFocus: false,
      breakpoints: {
        767: {
          padding: 0,
          gap: "5%",
          perPage: 2,
        },
      },
    }).mount(); */
  }
  if (slider02) {
    slider02.forEach(function (element) {
      const slideContents = element.querySelectorAll(".splide__slide");
      const slideLength = slideContents.length;

      const splide = new Splide(element, {
        type: slideLength >= 5 ? "slide" : "",
        perPage: 4,
        perMove: 1,
        pagination: false,
        dots: false,
        pagination: false,
        gap: "8%",
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: slideLength >= 5 ? true : false,
        drag: slideLength >= 5 ? true : false,
        snap: slideLength >= 5 ? true : false,
        breakpoints: {
          767: {
            type: slideLength >= 3 ? "slide" : "",
            arrows: slideLength >= 3 ? true : false,
            drag: slideLength >= 3 ? true : false,
            snap: slideLength >= 3 ? true : false,
            gap: "3%",
            perPage: 2,
            fixedWidth: "42%",
          },
        },
      });
      splide.mount();
    });
    /* new Splide(slider02, {
      perPage: 4,
      dots: false,
      type: "slide",
      //speed: 1200,
      //rewind: true,
      pagination: false,
      gap: "8%",
      pauseOnHover: false,
      pauseOnFocus: false,
      breakpoints: {
        767: {
          padding: 0,
          gap: "5%",
          perPage: 2,
        },
      },
    }).mount(); */
  }
  if (slider03) {
    slider03.forEach(function (element) {
      const slideContents = element.querySelectorAll(".splide__slide");
      const slideLength = slideContents.length;

      const splide = new Splide(element, {
        type: slideLength >= 5 ? "slide" : "",
        perPage: 4,
        perMove: 1,
        pagination: false,
        dots: false,
        pagination: false,
        gap: "8%",
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: slideLength >= 5 ? true : false,
        drag: slideLength >= 5 ? true : false,
        snap: slideLength >= 5 ? true : false,
        breakpoints: {
          767: {
            type: slideLength >= 3 ? "slide" : "",
            arrows: slideLength >= 3 ? true : false,
            drag: slideLength >= 3 ? true : false,
            snap: slideLength >= 3 ? true : false,
            gap: "3%",
            perPage: 2,
            fixedWidth: "42%",
          },
        },
      });
      splide.mount();
    });
    /* new Splide(slider03, {
      perPage: 4,
      dots: false,
      type: "slide",
      //speed: 1200,
      //rewind: true,
      pagination: false,
      gap: "8%",
      pauseOnHover: false,
      pauseOnFocus: false,
      breakpoints: {
        767: {
          padding: 0,
          gap: "5%",
          perPage: 2,
        },
      },
    }).mount(); */
  }
  /* if (".js-slider-gift") {
    new Splide(".js-slider-gift", {
      perPage: 2,
      dots: false,
      type: "slide",
      //speed: 1200,
      //rewind: true,
      pagination: false,
      gap: "8%",
      pauseOnHover: false,
      pauseOnFocus: false,
      breakpoints: {
        767: {
          padding: 0,
          gap: "5%",
          perPage: 2,
        },
      },
    }).mount();
  } */

  const slideElements = document.querySelectorAll(".js-slider-gift");

  slideElements.forEach(function (element) {
    const slideContents = element.querySelectorAll(".splide__slide");
    const slideLength = slideContents.length;

    const splide = new Splide(element, {
      type: slideLength >= 3 ? "slide" : "",
      perPage: 2,
      perMove: 1,
      pagination: false,
      //perMove: 1,
      //focus: "center",
      gap: 50,
      //pagenation: true,
      arrows: slideLength >= 3 ? true : false,
      drag: slideLength >= 3 ? true : false,
      snap: slideLength >= 3 ? true : false,
      breakpoints: {
        767: {
          gap: 15,
        },
      },
    });
    splide.mount();
  });
});
